import { UPDATE_USER } from '../actions/user-actions';

export default function userReducer(state = '', { type, payload }) {
    console.log(type, payload);
    switch (type) {
        case UPDATE_USER :
            console.log(UPDATE_USER)
            return payload.user;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/user-reducer.js